<p-dialog [header]="appService.commonModalHeader" [(visible)]="appService.isCommonModalVisible" [style]="{width: '30vw'}">
  <div class="text-center">{{appService.commonModalMsg}}</div>
 </p-dialog>